import * as actionTypes from '../constants/actionTypes';
export function showCopying(target) {
    return {
        type: actionTypes.SHOW_COPYING,
        target: target,
    };
}
export function showCopyingDone(target) {
    return {
        type: actionTypes.SHOW_COPYING_DONE,
        target: target,
    };
}
